import { logoutUser } from "../ApiCalls/authApi";

// export const toastStyle = () => {
//     return {
//         fontFamily: "Gotham-Rounded-Medium",
//         borderRadius: "10px",
//         background: "#333",
//         color: "#fff",
//     };
// };

/***************************
 * Common Utilities
 ***************************/

/**
 * Converts Quill delta object to HTML string
 * @param {*} quillDelta
 * @returns HTML string
 */
export const convertQuillToHtml = (quillDelta) => {
  var QuillDeltaToHtmlConverter =
    require("quill-delta-to-html").QuillDeltaToHtmlConverter;

  var cfg = {};

  var converter = new QuillDeltaToHtmlConverter(quillDelta.ops, cfg);

  var html = converter.convert();

  return html;
};

export const numberWithCommas = (number) => {
  if (!number) {
    return;
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

//Common Utility Functions

export const refreshPage = () => {
  window.location.reload();
};

export const getTime = (date) => {
  return date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};

export const getTime12Hour = (date) => {
  var today = new Date(date);
  return today.getHours() + ":" + today.getMinutes();
};

export const subtractMonths = (numOfMonths, date = new Date()) => {
  date.setMonth(date.getMonth() - numOfMonths);
  return date.toISOString().split("T")[0];
};

export const getTodayDate = () => {
  return new Date();
};

export const getTodayDateISO = () => {
  let date = new Date();
  return date.toISOString().split("T")[0];
};

export const getAge = (dateString) => {
  var today = new Date();
  var birthdate = new Date(dateString);
  var age = today.getFullYear() - birthdate.getFullYear();
  var m = today.getMonth() - birthdate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
    age--;
  }
  return age;
};

export const formatPrice = (p) => {
  if (!p) return "0.00";
  var result = parseFloat(p)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  return result;
};

export const formatDate = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");
  return stringDate[1] + " " + stringDate[2] + ", " + stringDate[3];
};

export const convertDateWithTime = (originalDate) => {
  const date = new Date(originalDate);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const formatYYYYMMDD = (date) => {
  const formatDate = new Date(date);
  const year = formatDate.getFullYear();
  let month = formatDate.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  let day = formatDate.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  return `${year}-${month}-${day}`;
};

export const formatDateWithTimeHMS = (date) => {
  const formatDate = new Date(date);

  // Get date components
  const year = formatDate.getFullYear();
  const month = String(formatDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(formatDate.getDate()).padStart(2, "0");

  // Get time components
  const hours = String(formatDate.getHours()).padStart(2, "0");
  const minutes = String(formatDate.getMinutes()).padStart(2, "0");
  const seconds = String(formatDate.getSeconds()).padStart(2, "0");

  // Assemble the formatted date and time without "T"
  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  return formattedDateTime;
};

// export const formatYYYYMMDD_HHSS = (date) => {
//  const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   const hours = String(date.getHours()).padStart(2, '0');
//   const minutes = String(date.getMinutes()).padStart(2, '0');

//   return `${year}-${month}-${day} ${hours}:${minutes}`;
// };
export const getDateToday = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate());

  const year = tomorrow.getFullYear();
  const month = String(tomorrow.getMonth() + 1).padStart(2, "0");
  const day = String(tomorrow.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const validateFileSize = (file) => {
  const maxSizeInBytes = 5 * 1024 * 1024; // 5MB

  if (file.size <= maxSizeInBytes) {
    return true; // File size is valid
  } else {
    return false; // File size is too large
  }
};

export const formatYear = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");
  return stringDate[3];
};

export const formatMonths = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");
  return stringDate[1] + ", " + stringDate[3];
};

export const formatDateWithTime = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");
  return (
    stringDate[1] +
    " " +
    stringDate[2] +
    ", " +
    stringDate[3] +
    " " +
    formatDate.toLocaleTimeString().replace(/(.*)\D\d+/, "$1")
  );
};

// export formatDate(date = null, format = "YYYY-mm-dd") {

// }

export const formatYYYYMMDD_HHMM = (date) => {
  const formatDate = new Date(date);

  // Get date components
  const year = formatDate.getFullYear();
  const month = String(formatDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(formatDate.getDate()).padStart(2, "0");

  // Get time components
  const hours = String(formatDate.getHours()).padStart(2, "0");
  const minutes = String(formatDate.getMinutes()).padStart(2, "0");

  // Assemble the formatted date and time without "T"
  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;

  return formattedDate;
};

export const formatDateNoTime = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");

  return stringDate[1] + " " + stringDate[2] + ", " + stringDate[3];
};

export const formatDateSlash = (date) => {
  var stringDate = date.split("-");

  return stringDate[1] + "/" + stringDate[2] + "/" + stringDate[0];
};

export const formatMDY = (date) => {
  var stringDate = date.split("-");
  return stringDate[1] + "-" + stringDate[2] + "-" + stringDate[0];
};

export const validateEmail = (email) => {
  if (email === "") {
    return true;
  } else {
    var filter =
      /^\s*[\w\-+_]+(\.[\w\-+_]+)*@[\w\-+_]+\.[\w\-+_]+(\.[\w\-+_]+)*\s*$/;
    return String(email).search(filter) !== -1;
  }
};

export const validateContact = (num) => {
  var mobileFilter = /((^(\+)(\d){12}$)|(^\d{11}$))/;
  var telFilter = /^[0-9]+(-[0-9]+)+$/;

  if (
    String(num).search(mobileFilter) !== -1 ||
    String(num).search(telFilter) !== -1
  ) {
    return true;
  } else {
    return false;
  }
};

export const formatNum = (num) => {
  return parseFloat(Math.round(num * 100) / 100).toFixed(2);
};

/***************************
 * Local Storage Utilities
 ***************************/

//return user data from local storage
export const getUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return username from local storage
export const getUserName = () => {
  const userStr = localStorage.getItem("username");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return first name from local storage
export const getFirstName = () => {
  const userStr = localStorage.getItem("first_name");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return first name from local storage
export const getLastName = () => {
  const userStr = localStorage.getItem("last_name");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return token from local storage
export const getToken = () => {
  return localStorage.getItem("token") || null;
};

//return token expiry from local storage
export const getTokenExpiry = () => {
  return localStorage.getItem("token_expiry") || null;
};

export const getUserType = () => {
  const user_type = localStorage.getItem("type");
  // const user_type = '"consumer"';
  if (user_type) return JSON.parse(user_type);
  else return null;
};

export const getTimeDetails = () => {
  const user_type = localStorage.getItem("time");
  // const user_type = '"consumer"';
  if (user_type) return JSON.parse(user_type);
  else return null;
};

export const getAddress1 = () => {
  const address1 = localStorage.getItem("address1");
  if (address1) return JSON.parse(address1);
  else return null;
};

export const getAddress2 = () => {
  const address2 = localStorage.getItem("address2");
  if (address2) return JSON.parse(address2);
  else return null;
};

export const getLat1 = () => {
  const latitude1 = localStorage.getItem("latitude1");
  if (latitude1) return JSON.parse(latitude1);
  else return null;
};

export const getLat2 = () => {
  const latitude2 = localStorage.getItem("latitude2");
  if (latitude2) return JSON.parse(latitude2);
  else return null;
};

export const getLong1 = () => {
  const longitude1 = localStorage.getItem("longitude1");
  if (longitude1) return JSON.parse(longitude1);
  else return null;
};

export const getLong2 = () => {
  const longitude2 = localStorage.getItem("longitude2");
  if (longitude2) return JSON.parse(longitude2);
  else return null;
};

//return store_address from local storage
export const getStreetAddress = () => {
  const address = localStorage.getItem("street_address");
  if (address) return JSON.parse(address);
  else return null;
};

//remove token from local storage
export const removeUserSession = () => {
  logoutUser();
  localStorage.clear();
};

//set the token and user from local storage
export const setUserSession = (token, api_key, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("api_key", api_key);
  localStorage.setItem("user", JSON.stringify(user));
};

export const nationalities = [
  { value: "AFGHAN", label: "AFGHAN" },
  { value: "ALBANIAN", label: "ALBANIAN" },
  { value: "ALGERIAN", label: "ALGERIAN" },
  { value: "AMERICAN", label: "AMERICAN" },
  { value: "ANDORRAN", label: "ANDORRAN" },
  { value: "ANGOLAN", label: "ANGOLAN" },
  { value: "ANTIGUANS", label: "ANTIGUANS" },
  { value: "ARGENTINEAN", label: "ARGENTINEAN" },
  { value: "ARMENIAN", label: "ARMENIAN" },
  { value: "AUSTRALIAN", label: "AUSTRALIAN" },
  { value: "AUSTRIAN", label: "AUSTRIAN" },
  { value: "AZERBAIJANI", label: "AZERBAIJANI" },
  { value: "BAHAMIAN", label: "BAHAMIAN" },
  { value: "BAHRAINI", label: "BAHRAINI" },
  { value: "BANGLADESHI", label: "BANGLADESHI" },
  { value: "BARBADIAN", label: "BARBADIAN" },
  { value: "BARBUDANS", label: "BARBUDANS" },
  { value: "BATSWANA", label: "BATSWANA" },
  { value: "BELARUSIAN", label: "BELARUSIAN" },
  { value: "BELGIAN", label: "BELGIAN" },
  { value: "BELIZEAN", label: "BELIZEAN" },
  { value: "BENINESE", label: "BENINESE" },
  { value: "BHUTANESE", label: "BHUTANESE" },
  { value: "BOLIVIAN", label: "BOLIVIAN" },
  { value: "BOSNIAN", label: "BOSNIAN" },
  { value: "BRAZILIAN", label: "BRAZILIAN" },
  { value: "BRITISH", label: "BRITISH" },
  { value: "BRUNEIAN", label: "BRUNEIAN" },
  { value: "BULGARIAN", label: "BULGARIAN" },
  { value: "BURKINABE", label: "BURKINABE" },
  { value: "BURMESE", label: "BURMESE" },
  { value: "BURUNDIAN", label: "BURUNDIAN" },
  { value: "CAMBODIAN", label: "CAMBODIAN" },
  { value: "CAMEROONIAN", label: "CAMEROONIAN" },
  { value: "CANADIAN", label: "CANADIAN" },
  { value: "CAPE VERDEAN", label: "CAPE VERDEAN" },
  { value: "CENTRAL AFRICAN", label: "CENTRAL AFRICAN" },
  { value: "CHADIAN", label: "CHADIAN" },
  { value: "CHILEAN", label: "CHILEAN" },
  { value: "CHINESE", label: "CHINESE" },
  { value: "COLOMBIAN", label: "COLOMBIAN" },
  { value: "COMORAN", label: "COMORAN" },
  { value: "CONGOLESE", label: "CONGOLESE" },
  { value: "COSTA RICAN", label: "COSTA RICAN" },
  { value: "CROATIAN", label: "CROATIAN" },
  { value: "CUBAN", label: "CUBAN" },
  { value: "CYPRIOT", label: "CYPRIOT" },
  { value: "CZECH", label: "CZECH" },
  { value: "DANISH", label: "DANISH" },
  { value: "DJIBOUTI", label: "DJIBOUTI" },
  { value: "DOMINICAN", label: "DOMINICAN" },
  { value: "DUTCH", label: "DUTCH" },
  { value: "EAST TIMORESE", label: "EAST TIMORESE" },
  { value: "ECUADOREAN", label: "ECUADOREAN" },
  { value: "EGYPTIAN", label: "EGYPTIAN" },
  { value: "EMIRIAN", label: "EMIRIAN" },
  { value: "EQUATORIAL GUINEAN", label: "EQUATORIAL GUINEAN" },
  { value: "ERITREAN", label: "ERITREAN" },
  { value: "ESTONIAN", label: "ESTONIAN" },
  { value: "ETHIOPIAN", label: "ETHIOPIAN" },
  { value: "FIJIAN", label: "FIJIAN" },
  { value: "FILIPINO", label: "FILIPINO" },
  { value: "FINNISH", label: "FINNISH" },
  { value: "FRENCH", label: "FRENCH" },
  { value: "GABONESE", label: "GABONESE" },
  { value: "GAMBIAN", label: "GAMBIAN" },
  { value: "GEORGIAN", label: "GEORGIAN" },
  { value: "GERMAN", label: "GERMAN" },
  { value: "GHANAIAN", label: "GHANAIAN" },
  { value: "GREEK", label: "GREEK" },
  { value: "GRENADIAN", label: "GRENADIAN" },
  { value: "GUATEMALAN", label: "GUATEMALAN" },
  { value: "GUINEA-BISSAUAN", label: "GUINEA-BISSAUAN" },
  { value: "GUINEAN", label: "GUINEAN" },
  { value: "GUYANESE", label: "GUYANESE" },
  { value: "HAITIAN", label: "HAITIAN" },
  { value: "HERZEGOVINIAN", label: "HERZEGOVINIAN" },
  { value: "HONDURAN", label: "HONDURAN" },
  { value: "HUNGARIAN", label: "HUNGARIAN" },
  { value: "ICELANDER", label: "ICELANDER" },
  { value: "INDIAN", label: "INDIAN" },
  { value: "INDONESIAN", label: "INDONESIAN" },
  { value: "IRANIAN", label: "IRANIAN" },
  { value: "IRAQI", label: "IRAQI" },
  { value: "IRISH", label: "IRISH" },
  { value: "ISRAELI", label: "ISRAELI" },
  { value: "ITALIAN", label: "ITALIAN" },
  { value: "IVORIAN", label: "IVORIAN" },
  { value: "JAMAICAN", label: "JAMAICAN" },
  { value: "JAPANESE", label: "JAPANESE" },
  { value: "JORDANIAN", label: "JORDANIAN" },
  { value: "KAZAKHSTANI", label: "KAZAKHSTANI" },
  { value: "KENYAN", label: "KENYAN" },
  { value: "KITTIAN AND NEVISIAN", label: "KITTIAN AND NEVISIAN" },
  { value: "KUWAITI", label: "KUWAITI" },
  { value: "KYRGYZ", label: "KYRGYZ" },
  { value: "LAOTIAN", label: "LAOTIAN" },
  { value: "LATVIAN", label: "LATVIAN" },
  { value: "LEBANESE", label: "LEBANESE" },
  { value: "LIBERIAN", label: "LIBERIAN" },
  { value: "LIBYAN", label: "LIBYAN" },
  { value: "LIECHTENSTEINER", label: "LIECHTENSTEINER" },
  { value: "LITHUANIAN", label: "LITHUANIAN" },
  { value: "LUXEMBOURGER", label: "LUXEMBOURGER" },
  { value: "MACEDONIAN", label: "MACEDONIAN" },
  { value: "MALAGASY", label: "MALAGASY" },
  { value: "MALAWIAN", label: "MALAWIAN" },
  { value: "MALAYSIAN", label: "MALAYSIAN" },
  { value: "MALDIVAN", label: "MALDIVAN" },
  { value: "MALIAN", label: "MALIAN" },
  { value: "MALTESE", label: "MALTESE" },
  { value: "MARSHALLESE", label: "MARSHALLESE" },
  { value: "MAURITANIAN", label: "MAURITANIAN" },
  { value: "MAURITIAN", label: "MAURITIAN" },
  { value: "MEXICAN", label: "MEXICAN" },
  { value: "MICRONESIAN", label: "MICRONESIAN" },
  { value: "MOLDOVAN", label: "MOLDOVAN" },
  { value: "MONACAN", label: "MONACAN" },
  { value: "MONGOLIAN", label: "MONGOLIAN" },
  { value: "MOROCCAN", label: "MOROCCAN" },
  { value: "MOSOTHO", label: "MOSOTHO" },
  { value: "MOTSWANA", label: "MOTSWANA" },
  { value: "MOZAMBICAN", label: "MOZAMBICAN" },
  { value: "NAMIBIAN", label: "NAMIBIAN" },
  { value: "NAURUAN", label: "NAURUAN" },
  { value: "NEPALESE", label: "NEPALESE" },
  { value: "NEW ZEALANDER", label: "NEW ZEALANDER" },
  { value: "NI-VANUATU", label: "NI-VANUATU" },
  { value: "NICARAGUAN", label: "NICARAGUAN" },
  { value: "NIGERIEN", label: "NIGERIEN" },
  { value: "NORTH KOREAN", label: "NORTH KOREAN" },
  { value: "NORTHERN IRISH", label: "NORTHERN IRISH" },
  { value: "NORWEGIAN", label: "NORWEGIAN" },
  { value: "OMANI", label: "OMANI" },
  { value: "PAKISTANI", label: "PAKISTANI" },
  { value: "PALAUAN", label: "PALAUAN" },
  { value: "PANAMANIAN", label: "PANAMANIAN" },
  { value: "PAPUA NEW GUINEAN", label: "PAPUA NEW GUINEAN" },
  { value: "PARAGUAYAN", label: "PARAGUAYAN" },
  { value: "PERUVIAN", label: "PERUVIAN" },
  { value: "POLISH", label: "POLISH" },
  { value: "PORTUGUESE", label: "PORTUGUESE" },
  { value: "QATARI", label: "QATARI" },
  { value: "ROMANIAN", label: "ROMANIAN" },
  { value: "RUSSIAN", label: "RUSSIAN" },
  { value: "RWANDAN", label: "RWANDAN" },
  { value: "SAINT LUCIAN", label: "SAINT LUCIAN" },
  { value: "SALVADORAN", label: "SALVADORAN" },
  { value: "SAMOAN", label: "SAMOAN" },
  { value: "SAN MARINESE", label: "SAN MARINESE" },
  { value: "SAO TOMEAN", label: "SAO TOMEAN" },
  { value: "SAUDI", label: "SAUDI" },
  { value: "SCOTTISH", label: "SCOTTISH" },
  { value: "SENEGALESE", label: "SENEGALESE" },
  { value: "SERBIAN", label: "SERBIAN" },
  { value: "SEYCHELLOIS", label: "SEYCHELLOIS" },
  { value: "SIERRA LEONEAN", label: "SIERRA LEONEAN" },
  { value: "SINGAPOREAN", label: "SINGAPOREAN" },
  { value: "SLOVAKIAN", label: "SLOVAKIAN" },
  { value: "SLOVENIAN", label: "SLOVENIAN" },
  { value: "SOLOMON ISLANDER", label: "SOLOMON ISLANDER" },
  { value: "SOMALI", label: "SOMALI" },
  { value: "SOUTH AFRICAN", label: "SOUTH AFRICAN" },
  { value: "SOUTH KOREAN", label: "SOUTH KOREAN" },
  { value: "SPANISH", label: "SPANISH" },
  { value: "SRI LANKAN", label: "SRI LANKAN" },
  { value: "SUDANESE", label: "SUDANES" },
  { value: "SURINAMER", label: "SURINAMER" },
  { value: "SWAZI", label: "SWAZI" },
  { value: "SWEDISH", label: "SWEDISH" },
  { value: "SWISS", label: "SWISS" },
  { value: "SYRIAN", label: "SYRIAN" },
  { value: "TAIWANESE", label: "TAIWANESE" },
  { value: "TAJIK", label: "TAJIK" },
  { value: "TANZANIAN", label: "TANZANIAN" },
  { value: "THAI", label: "THAI" },
  { value: "TOGOLESE", label: "TOGOLESE" },
  { value: "TONGAN", label: "TONGAN" },
  { value: "TRINIDADIAN OR TOBAGONIAN", label: "TRINIDADIAN OR TOBAGONIAN" },
  { value: "TUNISIAN", label: "TUNISIAN" },
  { value: "TURKISH", label: "TURKISH" },
  { value: "TUVALUAN", label: "TUVALUAN" },
  { value: "UGANDAN", label: "UGANDAN" },
  { value: "UKRAINIAN", label: "UKRAINIAN" },
  { value: "URUGUAYAN", label: "URUGUAYAN" },
  { value: "UZBEKISTANI", label: "UZBEKISTANI" },
  { value: "VENEZUELAN", label: "VENEZUELAN" },
  { value: "VIETNAMESE", label: "VIETNAMESE" },
  { value: "WELSH", label: "WELSH" },
  { value: "YEMENITE", label: "YEMENITE" },
  { value: "ZAMBIAN", label: "ZAMBIAN" },
  { value: "ZIMBABWEAN", label: "ZIMBABWEAN" },
];

export const phProvincesList = [
  { value: "ABRA", label: "ABRA" },
  { value: "AGUSAN DEL NORTE", label: "AGUSAN DEL NORTE" },
  { value: "AGUSAN DEL SUR", label: "AGUSAN DEL SUR" },
  { value: "AKLAN", label: "AKLAN" },
  { value: "ALBAY", label: "ALBAY" },
  { value: "ANTIQUE", label: "ANTIQUE" },
  { value: "APAYAO", label: "APAYAO" },
  { value: "AURORA", label: "AURORA" },
  { value: "BASILAN", label: "BASILAN" },
  { value: "BATAAN", label: "BATAAN" },
  { value: "BATANES", label: "BATANES" },
  { value: "BATANGAS", label: "BATANGAS" },
  { value: "BENGUET", label: "BENGUET" },
  { value: "BILIRAN", label: "BILIRAN" },
  { value: "BOHOL", label: "BOHOL" },
  { value: "BUKIDNON", label: "BUKIDNON" },
  { value: "BULACAN", label: "BULACAN" },
  { value: "CAGAYAN", label: "CAGAYAN" },
  { value: "CAMARINES NORTE", label: "CAMARINES NORTE" },
  { value: "CAMARINES SUR", label: "CAMARINES SUR" },
  { value: "CAMIGUIN", label: "CAMIGUIN" },
  { value: "CAPIZ", label: "CAPIZ" },
  { value: "CATANDUANES", label: "CATANDUANES" },
  { value: "CAVITE", label: "CAVITE" },
  { value: "CEBU", label: "CEBU" },
  { value: "COTABATO", label: "COTABATO" },
  { value: "DAVAO DE ORO", label: "DAVAO DE ORO" },
  { value: "DAVAO DEL NORTE", label: "DAVAO DEL NORTE" },
  { value: "DAVAO DEL SUR", label: "DAVAO DEL SUR" },
  { value: "DAVAO OCCIDENTAL", label: "DAVAO OCCIDENTAL" },
  { value: "DAVAO ORIENTAL", label: "DAVAO ORIENTAL" },
  { value: "DINAGAT ISLANDS", label: "DINAGAT ISLANDS" },
  { value: "EASTERN SAMAR", label: "EASTERN SAMAR" },
  { value: "GUIMARAS", label: "GUIMARAS" },
  { value: "IFUGAO", label: "IFUGAO" },
  { value: "ILOCOS NORTE", label: "ILOCOS NORTE" },
  { value: "ILOCOS SUR", label: "ILOCOS SUR" },
  { value: "ILOILO", label: "ILOILO" },
  { value: "ISABELA", label: "ISABELA" },
  { value: "KALINGA", label: "KALINGA" },
  { value: "LA UNION", label: "LA UNION" },
  { value: "LAGUNA", label: "LAGUNA" },
  { value: "LANAO DEL NORTE", label: "LANAO DEL NORTE" },
  { value: "LANAO DEL SUR", label: "LANAO DEL SUR" },
  { value: "LEYTE", label: "LEYTE" },
  { value: "MAGUINDANAO DEL NORTE", label: "MAGUINDANAO DEL NORTE" },
  { value: "MAGUINDANAO DEL SUR", label: "MAGUINDANAO DEL SUR" },
  { value: "MARINDUQUE", label: "MARINDUQUE" },
  { value: "MASBATE", label: "MASBATE" },
  { value: "MISAMIS OCCIDENTAL", label: "MISAMIS OCCIDENTAL" },
  { value: "MISAMIS ORIENTAL", label: "MISAMIS ORIENTAL" },
  { value: "MOUNTAIN PROVINCE", label: "MOUNTAIN PROVINCE" },
  { value: "NEGROS OCCIDENTAL", label: "NEGROS OCCIDENTAL" },
  { value: "NEGROS ORIENTAL", label: "NEGROS ORIENTAL" },
  { value: "NORTHERN SAMAR", label: "NORTHERN SAMAR" },
  { value: "NUEVA ECIJA", label: "NUEVA ECIJA" },
  { value: "NUEVA VIZCAYA", label: "NUEVA VIZCAYA" },
  { value: "OCCIDENTAL MINDORO", label: "OCCIDENTAL MINDORO" },
  { value: "ORIENTAL MINDORO", label: "ORIENTAL MINDORO" },
  { value: "PALAWAN", label: "PALAWAN" },
  { value: "PAMPANGA", label: "PAMPANGA" },
  { value: "PANGASINAN", label: "PANGASINAN" },
  { value: "QUEZON", label: "QUEZON" },
  { value: "QUIRINO", label: "QUIRINO" },
  { value: "RIZAL", label: "RIZAL" },
  { value: "ROMBLON", label: "ROMBLON" },
  { value: "SAMAR", label: "SAMAR" },
  { value: "SARANGANI", label: "SARANGANI" },
  { value: "SIQUIJOR", label: "SIQUIJOR" },
  { value: "SORSOGON", label: "SORSOGON" },
  { value: "SOUTH COTABATO", label: "SOUTH COTABATO" },
  { value: "SOUTHERN LEYTE", label: "SOUTHERN LEYTE" },
  { value: "SULTAN KUDARAT", label: "SULTAN KUDARAT" },
  { value: "SULU", label: "SULU" },
  { value: "SURIGAO DEL NORTE", label: "SURIGAO DEL NORTE" },
  { value: "SURIGAO DEL SUR", label: "SURIGAO DEL SUR" },
  { value: "TARLAC", label: "TARLAC" },
  { value: "TAWI-TAWI", label: "TAWI-TAWI" },
  { value: "ZAMBALES", label: "ZAMBALES" },
  { value: "ZAMBOANGA DEL NORTE", label: "ZAMBOANGA DEL NORTE" },
  { value: "ZAMBOANGA DEL SUR", label: "ZAMBOANGA DEL SUR" },
  { value: "ZAMBOANGA SIBUGAY", label: "ZAMBOANGA SIBUGAY" },
];

export const phCitiesList = [
  { value: "ALAMINOS", label: "ALAMINOS" },
  { value: "ANGELES", label: "ANGELES" },
  { value: "ANTIPOLO", label: "ANTIPOLO" },
  { value: "BACOLOD", label: "BACOLOD" },
  { value: "BACOLOR", label: "BACOLOR" },
  { value: "BACOOR", label: "BACOOR" },
  { value: "BAGO", label: "BAGO" },
  { value: "BAGUIO", label: "BAGUIO" },
  { value: "BAIS", label: "BAIS" },
  { value: "BALANGA", label: "BALANGA" },
  { value: "BATAC", label: "BATAC" },
  { value: "BATANGAS CITY", label: "BATANGAS CITY" },
  { value: "BAYAWAN", label: "BAYAWAN" },
  { value: "BAYBAY", label: "BAYBAY" },
  { value: "BAYUGAN", label: "BAYUGAN" },
  { value: "BISLIG", label: "BISLIG" },
  { value: "BIÑAN", label: "BIÑAN" },
  { value: "BOGO", label: "BOGO" },
  { value: "BORONGAN", label: "BORONGAN" },
  { value: "BUTUAN", label: "BUTUAN" },
  { value: "CABADBARAN", label: "CABADBARAN" },
  { value: "CABANATUAN", label: "CABANATUAN" },
  { value: "CABUYAO", label: "CABUYAO" },
  { value: "CADIZ", label: "CADIZ" },
  { value: "CAGAYAN DE ORO", label: "CAGAYAN DE ORO" },
  { value: "CALAMBA", label: "CALAMBA" },
  { value: "CALAPAN", label: "CALAPAN" },
  { value: "CALBAYOG", label: "CALBAYOG" },
  { value: "CALOOCAN", label: "CALOOCAN" },
  { value: "CANDON", label: "CANDON" },
  { value: "CANLAON", label: "CANLAON" },
  { value: "CARCAR", label: "CARCAR" },
  { value: "CARMONA", label: "CARMONA" },
  { value: "CATBALOGAN", label: "CATBALOGAN" },
  { value: "CAUAYAN", label: "CAUAYAN" },
  { value: "CAVITE CITY", label: "CAVITE CITY" },
  { value: "CEBU CITY", label: "CEBU CITY" },
  { value: "COTABATO CITY", label: "COTABATO CITY" },
  { value: "DAGUPAN", label: "DAGUPAN" },
  { value: "DANAO", label: "DANAO" },
  { value: "DAPITAN", label: "DAPITAN" },
  { value: "DASMARIÑAS", label: "DASMARIÑAS" },
  { value: "DAVAO CITY", label: "DAVAO CITY" },
  { value: "DIGOS", label: "DIGOS" },
  { value: "DIPOLOG", label: "DIPOLOG" },
  { value: "DUMAGUETE", label: "DUMAGUETE" },
  { value: "EL SALVADOR", label: "EL SALVADOR" },
  { value: "ESCALANTE", label: "ESCALANTE" },
  { value: "GAPAN", label: "GAPAN" },
  { value: "GENERAL SANTOS", label: "GENERAL SANTOS" },
  { value: "GENERAL TRIAS", label: "GENERAL TRIAS" },
  { value: "GINGOOG", label: "GINGOOG" },
  { value: "GUIHULNGAN", label: "GUIHULNGAN" },
  { value: "HIMAMAYLAN", label: "HIMAMAYLAN" },
  { value: "ILIGAN", label: "ILIGAN" },
  { value: "ILOILO CITY", label: "ILOILO CITY" },
  { value: "IMUS", label: "IMUS" },
  { value: "IRIGA", label: "IRIGA" },
  { value: "KABANKALAN", label: "KABANKALAN" },
  { value: "KIDAPAWAN", label: "KIDAPAWAN" },
  { value: "KORONADAL", label: "KORONADAL" },
  { value: "LA CARLOTA", label: "LA CARLOTA" },
  { value: "LAMITAN", label: "LAMITAN" },
  { value: "LAOAG", label: "LAOAG" },
  { value: "LAPU-LAPU", label: "LAPU-LAPU" },
  { value: "LAS PIÑAS", label: "LAS PIÑAS" },
  { value: "LEGAZPI", label: "LEGAZPI" },
  { value: "LIGAO", label: "LIGAO" },
  { value: "LIPA", label: "LIPA" },
  { value: "LUCENA", label: "LUCENA" },
  { value: "MAASIN", label: "MAASIN" },
  { value: "MABALACAT", label: "MABALACAT" },
  { value: "MAKATI", label: "MAKATI" },
  { value: "MALABON", label: "MALABON" },
  { value: "MALOLOS", label: "MALOLOS" },
  { value: "MANDALUYONG", label: "MANDALUYONG" },
  { value: "MANDAUE", label: "MANDAUE" },
  { value: "MANILA", label: "MANILA" },
  { value: "MARIKINA", label: "MARIKINA" },
  { value: "MEYCAUAYAN", label: "MEYCAUAYAN" },
  { value: "MUÑOZ", label: "MUÑOZ" },
  { value: "NAGA", label: "NAGA" },
  { value: "NAVOTAS", label: "NAVOTAS" },
  { value: "OLONGAPO", label: "OLONGAPO" },
  { value: "ORMOC", label: "ORMOC" },
  { value: "OROQUIETA", label: "OROQUIETA" },
  { value: "OZAMIZ", label: "OZAMIZ" },
  { value: "PAGADIAN", label: "PAGADIAN" },
  { value: "PALAYAN", label: "PALAYAN" },
  { value: "PANABO", label: "PANABO" },
  { value: "PARAÑAQUE", label: "PARAÑAQUE" },
  { value: "PASAY", label: "PASAY" },
  { value: "PASIG", label: "PASIG" },
  { value: "PASSI", label: "PASSI" },
  { value: "PUERTO PRINCESA", label: "PUERTO PRINCESA" },
  { value: "QUEZON CITY", label: "QUEZON CITY" },
  { value: "ROXAS", label: "ROXAS" },
  { value: "SAGAY", label: "SAGAY" },
  { value: "SAMAL", label: "SAMAL" },
  { value: "SAN CARLOS", label: "SAN CARLOS" },
  { value: "SAN FERNANDO", label: "SAN FERNANDO" },
  { value: "SAN JOSE", label: "SAN JOSE" },
  { value: "SAN JOSE DEL MONTE", label: "SAN JOSE DEL MONTE" },
  { value: "SAN JUAN", label: "SAN JUAN" },
  { value: "SAN PABLO", label: "SAN PABLO" },
  { value: "SAN PEDRO", label: "SAN PEDRO" },
  { value: "SANTA ROSA", label: "SANTA ROSA" },
  { value: "SANTIAGO", label: "SANTIAGO" },
  { value: "SANTO TOMAS", label: "SANTO TOMAS" },
  { value: "SILAY", label: "SILAY" },
  { value: "SIPALAY", label: "SIPALAY" },
  { value: "SORSOGON CITY", label: "SORSOGON CITY" },
  { value: "SURIGAO CITY", label: "SURIGAO CITY" },
  { value: "TABACO", label: "TABACO" },
  { value: "TACLOBAN", label: "TACLOBAN" },
  { value: "TACURONG", label: "TACURONG" },
  { value: "TAGAYTAY", label: "TAGAYTAY" },
  { value: "TAGBILARAN", label: "TAGBILARAN" },
  { value: "TAGUIG", label: "TAGUIG" },
  { value: "TAGUM", label: "TAGUM" },
  { value: "TALISAY", label: "TALISAY" },
  { value: "TANAUAN", label: "TANAUAN" },
  { value: "TANDAG", label: "TANDAG" },
  { value: "TANGUB", label: "TANGUB" },
  { value: "TANJAY", label: "TANJAY" },
  { value: "TARLAC CITY", label: "TARLAC CITY" },
  { value: "TAYABAS", label: "TAYABAS" },
  { value: "TOLEDO", label: "TOLEDO" },
  { value: "TRECE MARTIRES", label: "TRECE MARTIRES" },
  { value: "TUGUEGARAO", label: "TUGUEGARAO" },
  { value: "URDANETA", label: "URDANETA" },
  { value: "VALENCIA", label: "VALENCIA" },
  { value: "VALENZUELA", label: "VALENZUELA" },
  { value: "VICTORIAS", label: "VICTORIAS" },
  { value: "VIGAN", label: "VIGAN" },
  { value: "ZAMBOANGA CITY", label: "ZAMBOANGA CITY" },
];
